import { PaginadoTareas } from '../../pages/tareas/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { Condicionante } from '../../pages/autorizaciones/models'
import { baseApi } from './base.api'

export const condicionantesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP de condicionantes.
     * Las condicionantes pueden consultarse como listado general o por autorizacion,
     * y sus cuerpos se envian en snake_case para conservar el contrato del backend.
     */
    recuperarCondicionantes: builder.query<
      PaginadoTareas,
      { pagina: number; registrosPorPagina: number; nombre?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_CONDICIONANTES}`,
          params: keysToSnake(arg),
        }
      },
    }),
    recuperarCondicionanteporId: builder.query<Condicionante, string>({
      query: (idCondicionante) => `${window._env_.API_CONTEXTO_CONDICIONANTES}/${idCondicionante}`,
    }),

    /**
     * Recupera condicionantes relacionadas con una autorizacion especifica.
     */
    recuperarCondicionantesPorIdAutorizacion: builder.query<Condicionante, string>({
      query: (idAutorizacion) =>
        `${window._env_.API_CONTEXTO_CONDICIONANTES}/relacionado/${idAutorizacion}`,
    }),

    guardarCondicionante: builder.mutation({
      query: (condicionante) => {
        return {
          url: `${window._env_.API_CONTEXTO_CONDICIONANTES}`,
          method: 'POST',
          body: keysToSnake(condicionante),
        }
      },
    }),
    actualizarCondicionante: builder.mutation({
      query: ({ idCondicionante, ...condicionante }) => {
        return {
          url: `${window._env_.API_CONTEXTO_CONDICIONANTES}/${idCondicionante}`,
          method: 'PUT',
          body: keysToSnake(condicionante),
        }
      },
    }),

    recuperarCondicionantesAutocomplete: builder.query<any, string>({
      query: (nombre) => `${window._env_.API_CONTEXTO_CONDICIONANTES}/autocompletar/${nombre}`,
    }),
  }),
})

export const {
  useGuardarCondicionanteMutation,
  useRecuperarCondicionanteporIdQuery,
  useActualizarCondicionanteMutation,
  useLazyRecuperarCondicionanteporIdQuery,
  useLazyRecuperarCondicionantesQuery,
  useLazyRecuperarCondicionantesPorIdAutorizacionQuery,
  useRecuperarCondicionantesQuery,
  useLazyRecuperarCondicionantesAutocompleteQuery,
} = condicionantesApi
